import type { AnalyticsTracker } from './AnalyticsTracker';

/**
 * Composite Analytics Tracker
 *
 * Delegates analytics calls to multiple trackers (e.g., Mixpanel + Popow CRM)
 * Ensures that a failure in one tracker doesn't affect others
 */
export class CompositeAnalyticsTracker implements AnalyticsTracker {
  private trackers: AnalyticsTracker[];

  constructor(trackers: AnalyticsTracker[]) {
    this.trackers = trackers;
  }

  /**
   * 동적으로 tracker를 추가합니다.
   * CRM v2 등 비동기 초기화가 필요한 tracker를 나중에 추가할 때 사용
   */
  addTracker(tracker: AnalyticsTracker): void {
    this.trackers.push(tracker);
  }

  track(eventName: string, properties?: Record<string, any>): void {
    this.trackers.forEach(tracker => {
      try {
        tracker.track(eventName, properties);
      } catch {
        // Track 실패 시 무시 (다른 tracker에 영향 없음)
      }
    });
  }

  setUser(userId: string, properties: Record<string, any>): void {
    this.trackers.forEach(tracker => {
      try {
        const result = tracker.setUser(userId, properties);
        if (result instanceof Promise) {
          result.catch(() => {
            // setUser 실패 시 무시
          });
        }
      } catch {
        // setUser 실패 시 무시
      }
    });
  }

  clearUser(): void {
    this.trackers.forEach(tracker => {
      try {
        tracker.clearUser();
      } catch {
        // clearUser 실패 시 무시
      }
    });
  }
}
